import Projects from './Projects'
import ProjectDetails from './ProjectDetails'
import ProjectReport from './ProjectReport'

export default [{
  path: '/projects',
  name: 'Projects',
  component: Projects,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Projects',
    tour: false
  }
}, {
  path: '/project/:id',
  name: 'ProjectDetails',
  component: ProjectDetails,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Project Overview',
    tour: true
  }
}, {
  path: '/project/:project_id/report',
  name: 'ProjectReport',
  component: ProjectReport,
  meta: {
    auth: true,
    bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer',
    title: 'Project Overview'
  }
}]



// WEBPACK FOOTER //
// ./src/pages/project/router.js